import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";

export const getDynamicHeadingTextApi = function* getHeading(action) {
  let path = "/dynamic_text_setting/researches_text";
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getResearchAssessingApi = function* getResearchAssessing(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = `${URLS.RESEARCHES}${action.path}`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      if (typeof action.errorCallBack === "function") {
        yield call(action.errorCallBack, res);
      }
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    if (typeof action.errorCallBack === "function") {
      yield call(action.errorCallBack, error);
    }
    yield put({ type: "HIDE_LOADER" });
  }
};

export const getResearchAssessingDetailsApi =
  function* getResearchAssessingDetail(action) {
    yield put({ type: "SHOW_LOADER" });
    let path = URLS.RESEARCHES + `${action.id}/`;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

//-----------------------------------------------------------------------------------

export const getEngagementsApi = function* getEngagements(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      if (typeof action.errorCallBack === "function") {
        yield call(action.errorCallBack, res);
      }
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    if (typeof action.errorCallBack === "function") {
      yield call(action.errorCallBack, error);
    }
    yield put({ type: "HIDE_LOADER" });
  }
};

export const getEngagementDetails = function* getEngagementInfo(action) {
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.ENGAGEMENTS + `${action.id}/`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------

export const getArticlesListApi = function* getArticles(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};
//-----------------------------------------------------------------------------------

export const getFilterListApi = function* getFilterList(action) {
  let path = URLS.FILTER;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------

export const getResearchStatisticsApi = function* getResearchStatistics(
  action
) {
  yield put({ type: "SHOW_LOADER" });
  let path = URLS.RESEARCHES_STATISTICS;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
